import {
    CheckCircleOutlined,
    ExclamationCircleOutlined,
    FormOutlined,
    RetweetOutlined,
} from '@ant-design/icons'

import getColor from '~/lib/getColor'

import {
    DFM_ICON_CATEGORY_COLORS,
    DfmCategoryType,
    PENDING_FICTIV_REVIEW_CATEGORY,
    READY_TO_GO_CATEGORY,
    REVIEW_AND_APPROVE_CATEGORY,
    REVISION_REQUIRED_CATEGORY,
} from './constants'

const getIconStyle = (category: DfmCategoryType) => ({
    fontSize: '12px',
    padding: '4px 4px 0 0',
    color: getColor(DFM_ICON_CATEGORY_COLORS[category]),
})

type NumPartsPropsType = {
    category: DfmCategoryType
}

const NumPartsIcon = (props: NumPartsPropsType) => {
    const { category } = props

    const iconStyle = getIconStyle(category)

    switch (category) {
        case REVISION_REQUIRED_CATEGORY:
            return <ExclamationCircleOutlined style={iconStyle} />
        case REVIEW_AND_APPROVE_CATEGORY:
            return <FormOutlined style={iconStyle} />
        case PENDING_FICTIV_REVIEW_CATEGORY:
            return <RetweetOutlined style={iconStyle} />
        case READY_TO_GO_CATEGORY:
            return <CheckCircleOutlined style={iconStyle} />
        default:
            return null
    }
}

export default NumPartsIcon
